export default "__VITE_ASSET__Dh6$HR7e__"